"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayProcessTransaction = void 0;
/* eslint-disable @typescript-eslint/no-misused-promises */
const uuid_1 = require("uuid");
const mobx_1 = require("mobx");
const WorldpayInternalTransactionAPI = __importStar(require("../../../../api/worldpay/transaction/WorldpayInternalTransactionAPI"));
const enums_1 = require("../../global/enums");
const constants_1 = require("../constants");
const helpers_1 = require("../helpers");
const events_1 = require("@getgreenline/events");
class WorldpayProcessTransaction {
    constructor({ device, payment, transaction, laneId, logger, errorTracking, originalPayment, }, websocket) {
        this.websocket = websocket;
        this.transactionRetryCount = 0;
        this.isWaitingForWorldpayResponse = false;
        this.incrementTransactionRetries = () => {
            if (this.transactionRetryCount >= constants_1.MAX_WORLDPAY_RETRIES) {
                this.logger('Worldpay:incrementTransactionRetries:max_retries_reached', {
                    device: this.transaction,
                    payment: this.payment,
                    transaction: this.transaction,
                    laneId: this.laneId,
                });
                this.cancelTransaction();
                return;
            }
            this.transactionRetryCount++;
        };
        this.cancelTransaction = () => {
            this.logger('Worldpay:cancelTransaction', {
                device: this.transaction,
                payment: this.payment,
                transaction: this.transaction,
                laneId: this.laneId,
            });
            this.transactionRetryCount = 0;
            this.setIsWaitingForWorldpayResponse(false);
            if (this.worldpayTransactionInterval) {
                clearInterval(this.worldpayTransactionInterval);
                this.worldpayTransactionInterval = undefined;
            }
        };
        /**
         * @description This method is used to start the process of submitting a transaction to Worldpay.
         * @returns Promise<IWorldpayTransactionResponse | undefined>
         */
        this.processTransaction = () => __awaiter(this, void 0, void 0, function* () {
            this.logger('Worldpay:processTransaction', {
                device: this.transaction,
                payment: this.payment,
                transaction: this.transaction,
                laneId: this.laneId,
            });
            if (this.transaction.amount > 0) {
                return yield this.submitSale();
            }
            else {
                return yield this.submitReimbursement();
            }
        });
        this.generateOfflinePaymentId = () => {
            let offlinePaymentId = this.payment.offlinePaymentId || '';
            if (!this.payment.offlinePaymentId) {
                offlinePaymentId = (0, uuid_1.v4)();
                this.payment.setOfflinePaymentId(offlinePaymentId);
            }
            return offlinePaymentId;
        };
        this.checkTransaction = (payload, operationRetryInSec) => __awaiter(this, void 0, void 0, function* () {
            this.logger('Worldpay:checkTransaction:payload', payload);
            if (this.worldpayTransactionInterval) {
                this.errorTracking('Worldpay terminal is already running.', undefined, false);
                return;
            }
            const transactionResponse = yield this.getTransaction(payload, operationRetryInSec);
            // Reset transaction response
            this.setTransactionResponse(undefined);
            return transactionResponse;
        });
        this.getTransaction = (payload, operationRetryInSec) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            this.setIsWaitingForWorldpayResponse(true);
            const originalSubscriptionListener = (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.getSubscriptionOnOpen(events_1.EventsV2.EventModels.EventTopics.WP_TRANSACTION);
            // In case a websocket connection is dropped and reconnected, try to get the transaction before it was dropped
            (_b = this.websocket) === null || _b === void 0 ? void 0 : _b.addSubscriptionOnOpen(events_1.EventsV2.EventModels.EventTopics.WP_TRANSACTION, () => __awaiter(this, void 0, void 0, function* () {
                const response = yield WorldpayInternalTransactionAPI.getTransaction(payload);
                if (response.statusCode === enums_1.WorldpayResponseStatuses.RESPONSE_READY) {
                    this.logger('Worldpay:getTransaction:websocket:response_ready_after_reconnection', response);
                    this.setTransactionResponse(response);
                    this.cancelTransaction();
                }
            }));
            (_c = this.websocket) === null || _c === void 0 ? void 0 : _c.topicListener.addListener(events_1.EventsV2.EventModels.EventTopics.WP_TRANSACTION, events_1.EventsV2.EventModels.CrudEventTypes.CREATED, (message) => {
                if (message.data.offlinePaymentId !== payload.offlinePaymentId)
                    return;
                if (message.data.transactionId !== payload.transactionId)
                    return;
                this.logger('Worldpay:getTransaction:websocket:response_ready', message);
                this.setTransactionResponse(Object.assign(Object.assign({}, message), { message: message.message || 'Success' }));
                this.cancelTransaction();
            });
            // Polling
            this.worldpayTransactionInterval = setInterval(() => this.createIntervalCallback(payload), operationRetryInSec * 1000);
            yield (0, mobx_1.when)(() => !this.isWaitingForWorldpayResponse);
            if (originalSubscriptionListener) {
                (_d = this.websocket) === null || _d === void 0 ? void 0 : _d.addSubscriptionOnOpen(events_1.EventsV2.EventModels.EventTopics.WP_TRANSACTION, originalSubscriptionListener);
            }
            (_e = this.websocket) === null || _e === void 0 ? void 0 : _e.topicListener.removeListener(events_1.EventsV2.EventModels.EventTopics.WP_TRANSACTION, events_1.EventsV2.EventModels.CrudEventTypes.CREATED);
            return this.transactionResponse;
        });
        this.createIntervalCallback = (payload) => 
        // eslint-disable-next-line no-async-promise-executor
        new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            var _f;
            if ((_f = this.websocket) === null || _f === void 0 ? void 0 : _f.isListening(events_1.EventsV2.EventModels.EventTopics.WP_TRANSACTION, events_1.EventsV2.EventModels.CrudEventTypes.CREATED))
                return;
            if (!this.isWaitingForWorldpayResponse)
                return;
            try {
                const response = yield WorldpayInternalTransactionAPI.getTransaction(payload);
                if (response.statusCode === enums_1.WorldpayResponseStatuses.RESPONSE_READY) {
                    this.logger('Worldpay:getTransaction:polling:response_ready', response);
                    this.setTransactionResponse(response);
                    this.cancelTransaction();
                }
                this.incrementTransactionRetries();
                resolve(undefined);
            }
            catch (error) {
                this.cancelTransaction();
                reject(error);
            }
        }));
        this.setTransactionResponse = (transactionResponse) => {
            this.transactionResponse = transactionResponse;
        };
        this.setIsWaitingForWorldpayResponse = (isWaitingForWorldpayResponse) => {
            this.isWaitingForWorldpayResponse = isWaitingForWorldpayResponse;
        };
        this.submitSale = () => __awaiter(this, void 0, void 0, function* () {
            const tenantId = this.device.companyId.toString();
            const retailerId = this.device.locationId.toString();
            const asyncPayload = {
                tenantId,
                retailerId,
                offlinePaymentId: this.offlinePaymentId,
                payload: {
                    laneId: this.laneId,
                    deviceId: this.device.id,
                    transactionAmount: this.dollarAmount,
                },
            };
            this.logger('Worldpay:submitSale:asyncPayload', asyncPayload);
            try {
                const asyncResponse = yield WorldpayInternalTransactionAPI.submitSale(asyncPayload);
                this.logger('Worldpay:submitSale:asyncResponse', asyncPayload);
                if (asyncResponse.message === 'Success') {
                    const payload = {
                        transactionId: asyncResponse.data.transactionId,
                        tenantId,
                        retailerId,
                        offlinePaymentId: this.offlinePaymentId,
                    };
                    const response = yield this.checkTransaction(payload, asyncResponse.data.operationRetryInSec);
                    this.logger('Worldpay:submitSale:checkTransaction:response', response);
                    if (response) {
                        return response;
                    }
                    else {
                        throw new Error(`Worldpay terminal didn't respond to Greenline. Please submit the transaction again.`);
                    }
                }
            }
            catch (error) {
                this.errorTracking('Worldpay configuration error. Please check dashboard settings.', error, true);
                throw error;
            }
        });
        this.submitReimbursement = () => __awaiter(this, void 0, void 0, function* () {
            const tenantId = this.device.companyId.toString();
            const retailerId = this.device.locationId.toString();
            const noPreviousTransactionMessage = `The sale wasn't completed by Worldpay terminal. Please use other method for reimbursement.`;
            if (!this.originalPayment || !this.originalPayment.offlinePaymentId) {
                throw new Error(noPreviousTransactionMessage);
            }
            const originalTransaction = (0, helpers_1.getWorldpayTransaction)(this.originalPayment, this.transaction);
            if (!originalTransaction) {
                throw new Error(noPreviousTransactionMessage);
            }
            const metaData = (0, helpers_1.getWorldpayMetaDataFields)(originalTransaction);
            if (!metaData || !metaData.transactionId) {
                throw new Error(noPreviousTransactionMessage);
            }
            const asyncPayload = {
                tenantId,
                retailerId,
                offlinePaymentId: this.originalPayment.offlinePaymentId,
                payload: {
                    laneId: this.laneId,
                    deviceId: this.device.id,
                    originalTransactionId: metaData.transactionId,
                    transactionAmount: this.dollarAmount,
                },
            };
            this.logger('Worldpay:submitReimbursement:asyncPayload', asyncPayload);
            try {
                const asyncResponse = yield WorldpayInternalTransactionAPI.submitReimbursement(asyncPayload);
                this.logger('Worldpay:submitSale:asyncResponse', asyncPayload);
                if (asyncResponse.message === 'Success') {
                    const payload = {
                        transactionId: asyncResponse.data.transactionId,
                        tenantId,
                        retailerId,
                        offlinePaymentId: this.originalPayment.offlinePaymentId,
                    };
                    const response = yield this.checkTransaction(payload, asyncResponse.data.operationRetryInSec);
                    this.logger('Worldpay:submitSale:checkTransaction:response', response);
                    if (response) {
                        return response;
                    }
                    else {
                        throw new Error(`Worldpay terminal didn't respond to Greenline. Please submit the transaction again.`);
                    }
                }
            }
            catch (error) {
                this.errorTracking('Worldpay configuration error. Please check dashboard settings.', error, true);
                throw error;
            }
        });
        this.device = device;
        this.payment = payment;
        this.transaction = transaction;
        this.laneId = laneId;
        this.logger = logger;
        this.errorTracking = errorTracking;
        this.originalPayment = originalPayment;
        this.dollarAmount = transaction.amount / 100;
        this.offlinePaymentId = this.generateOfflinePaymentId();
    }
}
exports.WorldpayProcessTransaction = WorldpayProcessTransaction;
__decorate([
    mobx_1.observable
], WorldpayProcessTransaction.prototype, "transactionResponse", void 0);
__decorate([
    mobx_1.observable
], WorldpayProcessTransaction.prototype, "isWaitingForWorldpayResponse", void 0);
__decorate([
    mobx_1.action
], WorldpayProcessTransaction.prototype, "setTransactionResponse", void 0);
__decorate([
    mobx_1.action
], WorldpayProcessTransaction.prototype, "setIsWaitingForWorldpayResponse", void 0);
//# sourceMappingURL=WorldpayProcessTransaction.js.map